/* eslint-disable react/no-unknown-property */
import React from 'react';
import {
  Grid, ICON_BULLSEYE_ARROW, Message, Skeleton, Stack, Text,
} from '@doveit/bricks';
import { formatEuro } from '@doveit/hammer';
import * as styles from './ManagerGoalSimulationResultView.style';
import GoalMetricCard from '../goal-metric-card/GoalMetricCard';
import GoalMetricCardSkeleton from '../goal-metric-card/GoalMetricCard.skeleton';
import { Agent, GOAL_METRICS, ManagerGoal } from '../../../providers/api/dtos';
import AcceptManagerGoalAction, { AcceptManagerGoalActionProps } from '../../containers/accept-manager-goal-action/AcceptManagerGoalAction';

export interface ManagerGoalSimulationResultViewProps extends React.AriaAttributes {
  agentId: Agent['id'],
  target: number,
  goal?: ManagerGoal,
  loading?: boolean,
  onGoalAccepted?: AcceptManagerGoalActionProps['onSuccess'],
}

export const ManagerGoalSimulationResultView: React.FC<ManagerGoalSimulationResultViewProps> = ({
  agentId,
  target,
  goal,
  loading = false,
  onGoalAccepted,
  ...rest
}) => (
  <div
    css={styles.simulation}
    $isLoading={loading}
    {...rest}
  >
    <div css={styles.simulationContent}>
      <Stack gap={200}>
        <Stack gap={150}>
          <Message
            message={`Parametri di conversione per ${formatEuro(target)}`}
            icon={ICON_BULLSEYE_ARROW}
            type="primary"
          />
          <Text.BodySmall>
            Per raggiungere il tuo obiettivo di fatturato annuale, è necessario che il tuo team effettui un numero minimo di notizie, appuntamenti, mandati e vendite annuali.
          </Text.BodySmall>
        </Stack>

        <Grid gutter={75}>
          {(!loading && goal) && GOAL_METRICS.map((metric) => {
            const frequency = ['assignments', 'sales'].includes(metric) ? 'monthly' : 'weekly';

            return (
              <Grid.Unit key={metric} size={{ MD: 1 / 2, LG: 1 / 4 }}>
                <GoalMetricCard
                  avgCommission={goal.averageCommission}
                  metric={metric}
                  target={goal.metrics[metric].yearly.goal}
                  frequency={frequency}
                  targetByFrequency={goal.metrics[metric][frequency].forecast}
                />
              </Grid.Unit>
            );
          })}
          {loading && (
            <>
              <Grid.Unit size={{ MD: 1 / 2, LG: 1 / 4 }}>
                <GoalMetricCardSkeleton />
              </Grid.Unit>
              <Grid.Unit size={{ MD: 1 / 2, LG: 1 / 4 }}>
                <GoalMetricCardSkeleton />
              </Grid.Unit>
              <Grid.Unit size={{ MD: 1 / 2, LG: 1 / 4 }}>
                <GoalMetricCardSkeleton />
              </Grid.Unit>
              <Grid.Unit size={{ MD: 1 / 2, LG: 1 / 4 }}>
                <GoalMetricCardSkeleton />
              </Grid.Unit>
            </>
          )}
        </Grid>
      </Stack>
    </div>
    <div
      css={styles.simulationAction}
      $isLoading={loading}
    >
      {!loading && goal && (
        <AcceptManagerGoalAction
          agentId={agentId}
          target={goal.target.manager}
          onSuccess={onGoalAccepted}
        />
      )}
      {/** TODO action skeleton: https://doveit.atlassian.net/browse/DOVE-14727 */}
      {loading && (
        <Skeleton
          height="3rem"
          width="12rem"
        />
      )}
    </div>
  </div>
);
